export enum Route {
    Customers = "customers",
    CustomersExists = "customers/exists",
    CustomersSearch = "customers/search"
}
